import React, { useEffect, useRef } from 'react';
import { Box, Heading, Text, Button, VStack, Icon } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { FaSearch, FaHome, FaChartLine } from 'react-icons/fa';

const NotFound = () => {
  const originalTitleRef = useRef(null);
  const robotsRef = useRef(null);

  useEffect(() => {
    if (originalTitleRef.current === null) {
      originalTitleRef.current = document.title;
    }

    let robots = document.head.querySelector('meta[name="robots"]');
    const created = !robots;
    const initialContent = robots?.getAttribute('content') || null;

    if (!robots) {
      robots = document.createElement('meta');
      robots.setAttribute('name', 'robots');
      document.head.appendChild(robots);
    }

    robots.setAttribute('content', 'noindex, follow');
    robotsRef.current = { element: robots, initialContent, created };
    document.title = 'Page Not Found | DCF Teacher';

    return () => {
      document.title = originalTitleRef.current || 'DCF Teacher';

      const entry = robotsRef.current;
      if (!entry) return;

      if (entry.created) {
        entry.element.remove();
      } else if (entry.initialContent === null) {
        entry.element.removeAttribute('content');
      } else {
        entry.element.setAttribute('content', entry.initialContent);
      }
    };
  }, []);

  return (
    <Box 
      minH="calc(100vh - var(--nav-h))" 
      display="flex" 
      alignItems="center" 
      justifyContent="center"
      p={8}
    >
      <VStack gap={6} textAlign="center" maxW="500px">
        <Icon as={FaSearch} boxSize={16} color="gray.400" />
        
        <Heading as="h1" size="2xl" color="gray.700">
          404
        </Heading>
        
        <Heading as="h2" size="lg" color="gray.600" fontWeight="medium">
          Page Not Found
        </Heading>
        
        <Text color="gray.500" fontSize="lg">
          The page you're looking for doesn't exist or may have been moved.
          If you were looking for a stock, try searching from the browse page.
        </Text>
        
        <VStack gap={3} pt={4} w="100%">
          <Button
            as={RouterLink}
            to="/browse"
            colorPalette="blue"
            size="lg"
            w="100%"
            maxW="250px"
            leftIcon={<FaChartLine />}
          >
            Browse Stocks
          </Button>
          
          <Button
            as={RouterLink}
            to="/"
            variant="outline"
            size="lg"
            w="100%"
            maxW="250px"
            leftIcon={<FaHome />}
          >
            Go Home
          </Button>
        </VStack>
      </VStack>
    </Box>
  );
};

export default NotFound;
